module.exports = __webpack_public_path__ + "static/media/imagen_sin_resultados.b30315fa.svg";